<template>
    <UTooltip
        :text="tooltip"
    >
        <UButton
            class="w-full justify-center"
            :disabled="range.disabled"
            :active="range.selected"
            active-variant="solid"
            active-color="primary"
            variant="subtle"
            size="xs"
            :icon="icon"
            :data-col="range.label"
            @click="range.onClick"
        >
            {{ range.label }}
        </UButton>
    </UTooltip>
</template>

<script setup lang="ts">
import {DateRangeMatrix} from '@/dateUtils/v2/DateRangeMatrix'
import {DateRange} from '@/dateUtils/DateRange'
import {computed} from 'vue'
import {useCachedT} from '@/services/useCachedI18n'

const props = defineProps<{ range: DateRangeMatrix, status: (dateRange: DateRange) => 'Completed' | 'DueReporting' | undefined }>()

const {cachedT} = useCachedT()

const icon = computed(() => {
    const status = props.status(props.range.range)
    if (status === 'Completed') return 'i-ph-check'
    if (status === 'DueReporting') return 'i-ph-warning'
    return undefined
})

const tooltip = computed(() => {
    const status = props.status(props.range.range)
    if (status === 'Completed') return cachedT('vat-report.submitted')
    if (status === 'DueReporting') return cachedT('vat-report.due_reporting')
    return ''
})

</script>

<style scoped>

</style>